import { initAndGetAnalyticsSdk } from '@mmt/event-logger';
import {
  generateJourneyId,
  getGlobalData,
  getJourneyId,
  getPdtRequestId,
  getRequestId,
  getSubPageName,
  PDT_REQUEST_ID,
  removeEmpty,
  DEFAULT_SEARCH_CONTEXT,
} from './analytics-utils';
import { LOB, TEMPLATE_ID, TOPIC_NAME } from './analytics-constants';
import { getCmpDetails } from '../client/common/src/utils/utils';
import { getAffiliate } from '../client/common/utils/appUtils';
import { getUrlParamsMapV2, isAgentLoggedIn } from '../client/common/utils/browserUtils';
import { getCookie } from '../client/common/service/cookieService';

let page_name = '';
let page_version = '';

export const init = (pageName, version) => {
  if (pageName) {
    page_name = pageName;
  }
  if (version) {
    page_version = version;
  }
  if (window) {
    if (!window.AnalyticsSdk) {
      window.AnalyticsSdk = initAndGetAnalyticsSdk({
        // This is commented, there will be changes from common side, besides
        // replacing they have to merge the object
        // runtimeContextProvider: {
        //   getUserContext,
        //   getDeviceContext,
        // },
      });
    }
    return window.AnalyticsSdk;
  }
  return initAndGetAnalyticsSdk({
    // runtimeContextProvider: {
    //   getUserContext,
    //   getDeviceContext,
    // },
  });
};

export const captureEvent = (eventDetails, needNewJourneyId, addon) => {
  const sdk = init();
  const trackingCookie = getCookie('track');
  const {
    lob_category,
    search_context,
    error_details_list,
    previous_page,
    experiment_details,
    event_detail = {},
    pageContextPageType = '',
    user_context = {},
    adobe_analytics,
  } = getGlobalData();
  const { isXdmEvent = true, ...mainEventDetails } = eventDetails;
  const eventLogger = {
    page_context: removeEmpty({
      lob: LOB,
      lob_category,
      // sub_lob: SUB_LOB,
      page_name,
      page_type: pageContextPageType,
      subpage_name: getSubPageName(),
      funnel_step: page_name,
      page_url: window.location.href,
      prev_page_name: previous_page,
    }),
    campaign_details: {
      campaign_name: getCmpDetails()?.cmp,
      campaign_key: getCmpDetails()?.cmp,
    },
    event_detail: removeEmpty({
      page_version,
      ...event_detail,
      ...mainEventDetails,
    }),
    event_tracking_context: removeEmpty({
      topic_name: TOPIC_NAME,
      template_id: TEMPLATE_ID,
      request_id: getRequestId(),
      affiliate_id: getAffiliate(),
      [PDT_REQUEST_ID]: [getPdtRequestId()],
      env: 'prod',
      time_zone: 'Asia/Calcutta',
      journey_id: needNewJourneyId ? generateJourneyId() : getJourneyId(),
      organisation: 'MMT',
      bu: 'holidays',
      funnel_source: 'mmt',
      funnel_entry:
        getUrlParamsMapV2()?.quoteRequestId || getUrlParamsMapV2()?.psmQID ? 'PSM' : 'Online',
    }),
    search_context: search_context || DEFAULT_SEARCH_CONTEXT,
    user_context: {
      user_type: isAgentLoggedIn() ? 'AGENT' : 'PERSONAL',
      ...user_context,
    },
    adobe_analytics: removeEmpty(adobe_analytics || {}),
    ...(experiment_details && Object.keys(experiment_details).length > 0 && { experiment_details }),
    ...(error_details_list && error_details_list.length > 0 && { error_details_list }),
    ...(addon && {
      addon_details: [...addon],
    }),
  };

  if (trackingCookie === 'true' && isXdmEvent) {
    sdk.pushToAll(eventLogger, { lob: 'holiday', destinationUrl: '' });
  } else {
    sdk.track(eventLogger, 'holiday');
  }
};
